module.exports = function() {
  return new Worker(__webpack_public_path__ + "83cd3a524956fbe49cf2.worker.js");
};